import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
	selector: 'autocomplete-dropdown',
	templateUrl: './fang-autocomplete-dropdown.component.html',
	styleUrls: ['./fang-autocomplete-dropdown.component.scss']
})

export class FangAutocompleteDropdownComponent {

	@Input() dropdownElements: string[];
	@Output() onSelect = new EventEmitter<string>();

	selectElement(element: string) {
		this.onSelect.emit(element);
	}
}
